import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const CONTAINER_HEIGHT = 400;
const CONTAINER_OFFSET = 200;

const StickyInAbsoluteContainer = ({ children, itemNumber }) => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: itemNumber * CONTAINER_HEIGHT + itemNumber * CONTAINER_OFFSET,
                height: CONTAINER_HEIGHT,
                width: '100%',
            }}
        >
            <Box
                sx={{
                    position: 'sticky',
                    top: '60px',
                    width: '100%',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

StickyInAbsoluteContainer.propTypes = {
    children: PropTypes.node,
    itemNumber: PropTypes.number,
};

export default StickyInAbsoluteContainer;
